module.exports = __webpack_public_path__ + "static/media/password.742686a3.svg";